// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".draft-home[data-v-defe540e]{width:900px}.draft-home .draft-name[data-v-defe540e]{height:60px;border-radius:10px;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}.draft-home .draft-title[data-v-defe540e]{font-weight:600}.draft-home .draft-box[data-v-defe540e]{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;margin-top:5px}", ""]);
// Exports
module.exports = exports;
